import useAjaxRequest from './useAjaxRequest';
import { URL_SAVE_COTATION } from '../config/endpoints';

const useSaveCotation = () => {
  const {
    response: { error, loading, data: cotation },
    performRequest,
  } = useAjaxRequest();

  const saveCotation = (productData, userData, isIbc, agencyNumber) =>
    performRequest({
      method: 'post',
      url: URL_SAVE_COTATION(),

      data: {
        estruturaComercial: isIbc
          ? [
              {
                empresa: {
                  CNPJ: '360305000104',
                  nome: 'CAIXA',
                  pontoVenda: {
                    tipo: 'AGENCIA',
                    codigoExterno: agencyNumber,
                    canal: {
                      codigo: 'IBC',
                      nome: 'INTERNET BANKING',
                    },
                  },
                },
              },
            ]
          : [
              {
                empresa: {
                  CNPJ: '34020354000110',
                  nome: 'CAIXA SEGURADORA S.A.',
                },
              },
            ],
        clientes: [
          {
            tipoCliente: {
              codigo: 'TITUL',
              descricao: 'Titular',
            },
            ...userData,
          },
        ],
        ...productData,
      },
    });

  return { error, loading, cotation, saveCotation };
};

export default useSaveCotation;
